import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './banner.module.scss';
import { useDismissibleBanner } from './hooks/useDismissibleBanner';

export type BannerProps = {
  message: string;
  startsAt?: Date;
  endsAt?: Date;
  isDismissable?: boolean;
};

export function Banner({
  message,
  startsAt,
  endsAt,
  isDismissable = false,
}: BannerProps) {
  const now = new Date();
  const { isDismissed, dismissBanner } = useDismissibleBanner(message, endsAt);

  if ((startsAt && now < startsAt) || (endsAt && now > endsAt)) {
    return null;
  }

  if (isDismissable && isDismissed) {
    return null;
  }

  return (
    <div className={styles['banner']}>
      <p className={styles['banner-message']}>{message}</p>
      {isDismissable && (
        <IconButton
          className={styles['banner-dismiss']}
          onClick={dismissBanner}
          size="small"
          aria-label="Dismiss banner"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </div>
  );
}

export default Banner;
